import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import FrameBase from '../../../frame/FrameBase';
import Extensions from '../../../apps/Extensions';
import encodePathForUriComponent from '../../../utils/pathUtil/encodePathForUriComponent';
import stripDesignTrunkFromPath from '../../../utils/pathUtil/stripDesignTrunkFromPath';
import { CircularProgress, withStyles, createStyles } from '@material-ui/core';
import CsvPreview from './CsvPreview';
import urlUtils from '../../../utils/url';

var isCsvFile = function isCsvFile(filePath) {
  return filePath && filePath.endsWith('.csv');
};

var isEmailTemplate = function isEmailTemplate(filePath) {
  return filePath && filePath.endsWith('.ehtml');
};
/**
 * @extends {React.Component<import('./types').FilePreviewProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */


var FilePreview =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FilePreview, _React$Component);

  function FilePreview() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FilePreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilePreview)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      loaded: false
    };
    return _this;
  }

  _createClass(FilePreview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          workspace = _this$props.workspace,
          path = _this$props.path,
          fileName = _this$props.fileName,
          accessToken = _this$props.accessToken,
          width = _this$props.width,
          height = _this$props.height,
          classes = _this$props.classes,
          frameBaseRef = _this$props.frameBaseRef,
          rest = _objectWithoutProperties(_this$props, ["workspace", "path", "fileName", "accessToken", "width", "height", "classes", "frameBaseRef"]);

      var fileWorkspace = encodeURIComponent(workspace);
      var fixedPath = stripDesignTrunkFromPath(encodePathForUriComponent(path));
      var search = urlUtils.stringifySearchParams({
        file: fileName,
        accessToken: accessToken
      });
      var url = "embed/PreviewFile?".concat(search, "#workspace/").concat(fileWorkspace, "/").concat(fixedPath);
      if (isCsvFile(path)) return React.createElement(CsvPreview, {
        workspace: workspace,
        path: path
      });
      return React.createElement(React.Fragment, null, !this.state.loaded && React.createElement(CircularProgress, {
        className: classes.loadingIndicator
      }), workspace && isEmailTemplate(path) && React.createElement(Extensions, {
        extensionFor: "EmailPreview",
        workspace: workspace,
        path: path
      }), React.createElement(FrameBase, Object.assign({
        ref: frameBaseRef,
        useEcrionServer: true,
        url: url,
        width: width,
        height: height,
        namespace: "File",
        style: {
          visibility: this.state.loaded ? 'visible' : 'hidden'
        },
        onLoaded: function onLoaded() {
          _this2.setState({
            loaded: true
          });
        }
      }, rest)));
    }
  }]);

  return FilePreview;
}(React.Component);

var styles = createStyles({
  loadingIndicator: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-25px',
    marginTop: '-25px'
  }
});
FilePreview.defaultProps = {
  width: '100%',
  height: 'auto'
};
export default withStyles(styles, {
  name: 'ECFilePreview'
})(FilePreview);